export const populateFieldsWithPreviousValues = (props, data) => {
  if (data && typeof data === 'object') {
    Object.entries(data).forEach(([key, value]) => {
      props.form.change(key, value);
    });
  }
};
